import React, { Component } from 'react';
import { connect } from 'react-redux';

import { initModal, pushModal } from 'shared/actions/modal.action';

import Dim from 'web/components/common/modal/common/Dim';
import Logo from 'web/components/common/modal/common/Logo';

import { logout } from 'shared/actions/auth.action';

@connect(
  (state, props) => ({
    auth: state.shared.auth,
    modal: state.shared.modal,
  }),
  {
    initModal,
    pushModal,
    logout,
  },
)
class SignupInRealclass extends Component {
  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    return (
      <Dim onClick={this.props.popupHandler.close}>
        <div
          className="modal"
          style={{
            position: 'relative',
            width: '320px',
            padding: '120px 40px 60px',
            backgroundColor: '#fff',
            color: '#000',
            borderRadius: '10px',
            overflow: 'hidden',
            textAlign: 'center',
            fontSize: '14px',
            lineHeight: '1.4',
          }}
        >
          <Logo />
          <div>
            <p style={{ marginBottom: 20 }}>
              2020년 12월 17일부터 <br />
              닥터뮤지 신규 가입 및 구매는 <br />
              리얼클래스에서 가능합니다.
            </p>
            <p style={{ marginBottom: 20 }}>
              <a href="https://realclass.co.kr" style={{ color: 'blue' }}>
                리얼클래스
              </a>
              로 이동하시겠습니까?
            </p>
          </div>
          <a href="https://realclass.co.kr">
            <button
              style={{
                width: '50%',
                height: '40px',
                lineHeight: '40px',
                backgroundColor: '#3b3283',
                color: '#fff',
                position: 'absolute',
                left: '0',
                bottom: '0',
              }}
            >
              확인
            </button>
          </a>
          <button
            style={{
              width: '50%',
              height: '40px',
              lineHeight: '40px',
              backgroundColor: '#f4f4f4',
              color: '#3b3283',
              position: 'absolute',
              right: '0',
              bottom: '0',
            }}
            onClick={this.props.popupHandler.close}
          >
            취소
          </button>
        </div>
      </Dim>
    );
  }
}

export default SignupInRealclass;
